import { useState } from 'react';
import { Mail } from 'lucide-react';
import ContactModal from './ContactModal';

export default function Footer() {
  const [showContactModal, setShowContactModal] = useState(false);

  return (
    <>
      {/* Footer */}
      <footer className="border-t border-zinc-800/50 bg-[#050505]/80 backdrop-blur-sm mt-auto">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-6">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="font-mono text-xs text-zinc-600 tracking-wider">
              © 2026 BLK MRKT
            </p>
            <button
              onClick={() => setShowContactModal(true)}
              className="font-mono text-xs text-zinc-500 hover:text-tiffany-500 transition-colors tracking-wider flex items-center gap-2"
              data-testid="footer-contact-link"
            >
              <Mail className="w-3 h-3" />
              CONTACT
            </button>
          </div>
        </div>
      </footer>

      {/* Contact Modal */}
      <ContactModal 
        isOpen={showContactModal} 
        onClose={() => setShowContactModal(false)} 
      />
    </>
  );
}
